import { render, staticRenderFns } from "./ItemCharacteristics.vue?vue&type=template&id=2cd01c34"
import script from "./ItemCharacteristics.vue?vue&type=script&lang=js"
export * from "./ItemCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./ItemCharacteristics.vue?vue&type=style&index=0&id=2cd01c34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports